<p-dialog [(visible)]="showExportDialog" [modal]="true" header="Export Notes" styleClass="export-dialog">
	<ng-container *ngIf="showCSVOption">
		<h4>Export As:</h4>
	
		<div class="p-formgroup-inline">
			<div class="p-field-checkbox">
				<p-radioButton value="pdf" [(ngModel)]="exportType" inputId="pdf"></p-radioButton>
				<label for="pdf">PDF</label>
			</div>

			<div class="p-field-checkbox">
				<p-radioButton value="csv" [(ngModel)]="exportType" inputId="csv"></p-radioButton>
				<label for="csv">CSV</label>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="exportType == 'pdf'">
		<h4>Orientation:</h4>

		<div class="p-formgroup-inline">
			<div class="p-field-checkbox">
				<p-radioButton value="portrait" [(ngModel)]="pdfExportOptions.orientation" inputId="portrait"></p-radioButton>
				<label for="portrait">Portrait</label>
			</div>

			<div class="p-field-checkbox">
				<p-radioButton value="landscape" [(ngModel)]="pdfExportOptions.orientation" inputId="landscape"></p-radioButton>
				<label for="landscape">Landscape</label>
			</div>
		</div>

		<div class="p-field-checkbox p-mt-3">
			<p-checkbox [(ngModel)]="pdfExportOptions.printerFriendly" [binary]="true" inputId="printerFriendly"></p-checkbox>
			<label for="printerFriendly">Printer Friendly</label>
		</div>
	</ng-container>

	<div class="p-field-checkbox p-mt-3">
		<p-checkbox [(ngModel)]="pdfExportOptions.showComments" [binary]="true" inputId="showComments"></p-checkbox>
		<label for="showComments">Show Comments</label>
	</div>

	<ng-template pTemplate="footer">
		<ng-container *ngIf="loading && exportType == 'pdf'">
			<p-message severity="info" text="{{exportMessage}}"></p-message>
		</ng-container>

		<ng-container *ngIf="!loading">
			<p-button *ngIf="exportType == 'pdf'" label="Export to PDF" icon="pi pi-file-pdf"
				styleClass="p-button-secondary p-mr-0" (click)="onExportToPDFClicked()" iconPos="right">
			</p-button>
		</ng-container>

		<p-button *ngIf="exportType == 'csv'" label="Export to CSV" icon="pi pi-file-excel" iconPos="right"
			styleClass="p-button-secondary p-mr-0" (click)="onExportToCSVClicked()">
		</p-button>
	</ng-template>
</p-dialog>